export type EndpointSetting = {
  method: string,
  endpoint: string,
  params?: { [paramName: string]: any },
  body?: { [prop: string]: any },
  caller?: (state: any, action: any, endpointName: any) => any,
  callerService?: (payload: any) => any, 
  api: any
}

export enum EnumReduces {
  STORE = "store",
  PRODUCT = "product"
}

export type TypeCommonAPIState<T> = {
  loading: boolean,
  success: boolean,
  error: any,
  data: T,
  filter?: any,
  called: boolean,
  primaryKeys?: string[]
}

export type TypeServices = {
  [prop: string]: (input: { params?: any, body?: any }, headers?: any) => any
}